<template><svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="4" width="5" height="11" fill="#1c65ac"/>
<path d="M6.5 14L0.870835 8L12.1292 8L6.5 14Z" fill="#1c65ac"/>
<rect x="2" y="16" width="9" height="2" fill="#1c65ac"/>
</svg></template><script>export default {}</script>
